// Add your custom JS here.


import { Collapse } from 'bootstrap';
import Slick from 'slick-carousel';  

let $ = jQuery;

//jQuery( document ).on("ready", function(e){

 
 
    markImagesWithCaption();

    setTimeout(()=>{
        let $slick_carousel = $('.fullscreen-slider__cont-wrapper');

        $slick_carousel.on('init', function(event, slick) {
            setTimeout(function(){
                $('.slick-slide.slick-current').addClass('animate-content');
            },200);
        });

        $slick_carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            if( $('.animate-content') ){
                $('.animate-content').removeClass('animate-content');
            }
        });

        $slick_carousel.on('afterChange', function(event, slick, currentSlide, nextSlide){
           
            $('.slick-slide.slick-active').addClass('animate-content');
        });

        $slick_carousel.slick({
            arrows:false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite:true,
            dots:true,
            fade: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            speed: 600,
            dotsClass:'swiper-pagination container-fluid',
            cssEase: 'ease',
            autoplay:true,
            autoplaySpeed:8000
            //slide:'.fullscreen-slider__slide'
        });

        
        
    },300);

    calcSliderMarginBottom();

    

    $(window).on('resize',()=>{ 
        calcSliderMarginBottom(); 
    });

    //Get the button
    let mybutton = document.getElementById("btn-back-to-top");

    // When the user scrolls down 20px from the top of the document, show the button
    $(window).on('scroll', function(){
        console.log('scroll');
        scrollFunction();
    });

    function scrollFunction() {
        if(mybutton){
            if (
                document.body.scrollTop > 20 ||
                document.documentElement.scrollTop > 20
            ) {
                mybutton.style.display = "block";
            } else {
                mybutton.style.display = "none";
        }
        }
    }
        // When the user clicks on the button, scroll to the top of the document
        mybutton.addEventListener("click", backToTop);

    function backToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0; 
    }


    function calcSliderMarginBottom(){

        if( $('.fullscreen-slider').length > 0 ){
            let hs = [];

            $('.fullscreen-slider:first-of-type .fullscreen-slide__content').each( function(){
                hs.push( Number.parseInt( $(this).height() ) );
            },hs );
            
            
            if( $('.fullscreen-slide__content').hasClass( 'entry-meta' ) ){
            }else{
                $('.fullscreen-slider:first-of-type').css('padding-bottom', Math.max( ...hs ) +'px');
            }

            

        }
    }

    function markImagesWithCaption(){
        $('.wp-block-image .wp-element-caption').each( function(){
            $(this).closest('.wp-block-image').addClass('has-caption');
        } );
        $('.wp-block-embed .wp-element-caption').each( function(){
            $(this).closest('.wp-block-embed').addClass('has-caption');
        } );

        $('.wp-block-gallery > .wp-element-caption').each( function(){
            $(this).closest('.wp-block-gallery').addClass('has-caption');
        } );
    }
//});